// extracted by mini-css-extract-plugin
module.exports = {"info":"ModalContent_info__2vK8k","title":"ModalContent_title__lZRRS","description":"ModalContent_description__ER7Nr"};